import type { PageParams, PageRes } from '@/types'
import request from '@/utils/request'
import type { RoguelikeScoreDTO, RoguelikeScoreListItem } from './type'

export function roguelikeScoreSaveApi(data: RoguelikeScoreDTO) {
  return request<null>({
    url: 'roguelike-score/save',
    method: 'POST',
    data,
  })
}


export function getRoguelikeScoreListApi(params: PageParams & { isWeek?: 0 | 1 }) {
  return request<PageRes<RoguelikeScoreListItem[]>>({
    url: 'roguelike-score/list',
    params,
  })
}